export class AlicuotaIva {
    constructor(
        public readonly Id: number,
        public readonly Codigo: string | null,
        public readonly Nombre: string | null,
        public readonly Porcentaje: number,
        public readonly CodigoExterno: string | null,
        public  Activo: boolean
    ) { }
}

export class SearchAlicuotaIvaRequest {
    constructor(
        public readonly PageSize: number | null,
        public readonly PageNumber: number | null,
        public readonly OrderAscending: boolean | null,
        public readonly OrderFieldName: string | null,
        public readonly Codigo: string | null,
        public readonly Porcentaje: number | null,
        public readonly CodigoExterno: string | null,
        public readonly Nombre: string | null,
        public readonly VerSoloActivos: boolean | null
    ) { }
}

export class SaveAlicuotaIvaDto {
    constructor(
        public readonly Codigo: string | null,
        public readonly Nombre: string | null,
        public readonly Porcentaje: number,
        public readonly CodigoExterno: string | null,
        public readonly Activo: boolean
    ) { }
}

export class SearchAlicuotaIvaResponse {
    constructor(
      public readonly count: number,
      public readonly result: AlicuotaIva[]
  ) { }
}